import React from 'react';
import {usePosition} from "../../providers/ProjectPositionProvider";
import TalentCandidateScopeProvider, {
    TalentCandidateScopeContext
} from "./candidate-scope/TalentCandidateScopeProvider";
import LoadingSpinner from "../../components/LoadingSpinner";
import CandidatePayoutForm from "./candidate-scope/CandidatePayoutForm";
import PositionTimeline from "../project-position/components/PositionTimeline";

/**
 * PositionCandidateFixedFeeCostOverrideTab Component
 * 
 * This component handles cost override functionality for fixed fee projects.
 * It displays a simplified interface focused on talent payout and project timeline.
 * 
 * Key Features:
 * - Talent candidate scope management
 * - Candidate payout form for fixed fee structures
 * - Position timeline display
 * 
 * Usage: This component should only be used when project.isFixedFee() returns true
 */
const PositionCandidateFixedFeeCostOverrideTab = ({...props}) => {
    const {position} = usePosition();

    return (
        <React.Fragment>
            {/* Talent Candidate Scope Provider manages candidate-specific data and state */}
            <TalentCandidateScopeProvider candidate={position.assignedCandidate()}>
                <TalentCandidateScopeContext.Consumer>
                    {({isLoading, candidate}) => (
                        isLoading ? (
                            // Loading state while candidate data is being fetched
                            <div className="flex flex-col items-center py-5">
                                <LoadingSpinner size="lg"/>
                            </div>
                        ) : (candidate && (
                            // Render candidate payout form once data is loaded
                            <CandidatePayoutForm />
                        ))
                    )}
                </TalentCandidateScopeContext.Consumer>
            </TalentCandidateScopeProvider>

            {/* Position timeline component for tracking project milestones */}
            <PositionTimeline/>

            {/* Contract expenses table is commented out but could be enabled if needed */}
            {/*<PositionContractExpensesTable/>*/}
        </React.Fragment>
    );
};

PositionCandidateFixedFeeCostOverrideTab.propTypes = {};

export default PositionCandidateFixedFeeCostOverrideTab;